import React from 'react';
import { omitNonReactProps } from '~/services/utils';
import { IconProps } from '~/types/utils';
import { useTheme } from 'styled-components';

const Twitter = ({ fill, size = '24', ...otherProps }: IconProps) => {
	const theme = useTheme();
	return (
		<svg
			focusable="false"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill={fill ?? theme.colors.icon}
			{...omitNonReactProps(otherProps)}
		>
			<path d="M8.28251 21C15.8295 21 19.9592 14.4577 19.9592 8.7938C19.9592 8.60974 19.9592 8.42569 19.9512 8.24163C20.7515 7.63927 21.4478 6.87795 22 6.01624C21.2637 6.35925 20.4714 6.58514 19.6391 6.6939C20.4874 6.16683 21.1357 5.32185 21.4478 4.31791C20.6555 4.81152 19.7751 5.16289 18.8387 5.35531C18.0864 4.5187 17.022 4 15.8455 4C13.5806 4 11.7399 5.92421 11.7399 8.29183C11.7399 8.62648 11.7799 8.95275 11.8439 9.27067C8.43458 9.09498 5.40936 7.37992 3.38455 4.78642C3.03241 5.42224 2.83233 6.15846 2.83233 6.94488C2.83233 8.43406 3.56062 9.74754 4.65706 10.5172C3.98479 10.4921 3.35254 10.2997 2.80032 9.98179C2.80032 9.99852 2.80032 10.0153 2.80032 10.0404C2.80032 12.1152 4.21689 13.8553 6.08964 14.2485C5.7455 14.3489 5.38535 14.3991 5.0092 14.3991C4.7451 14.3991 4.489 14.374 4.2409 14.3238C4.7611 16.0305 6.28171 17.2687 8.07443 17.3022C6.66587 18.4567 4.89716 19.1427 2.97639 19.1427C2.64826 19.1427 2.32013 19.126 2 19.0842C3.80872 20.2889 5.96959 21 8.28251 21Z" />
		</svg>
	);
};

export default Twitter;
